export default __webpack_public_path__ + "static/media/Spin general_Interactive LightMix0040.9bf2f69b.webp";